__turbopack_context__.v({
  "root": "Search-module-scss-module__TeYSJG__root",
  "searchIcon": "Search-module-scss-module__TeYSJG__searchIcon",
});
